import { InjectionToken } from '@angular/core';

export const ENABLE_TEST_DATA_VIEWER = new InjectionToken<boolean>('enableTestDataViewer');
